import { call, restService } from './apiHelpers';

export const hierarchyService = {
  ...restService('hierarchy'),
  getTree: (params) => call('get', 'hierarchy/tree/', null, params),
  getForUser: (_, params) => call('get', 'hierarchy/tree/', null, params),
  getSummary: (params) => call('get', 'hierarchy/summary/', null, params),
  getTable: (params) => call('get', 'hierarchy/table/', null, params),
  getCoordinators: (generalId) =>
    call('get', `hierarchy/general-administrators/${generalId}/coordinators/`),
  getLeaders: (coordinatorId) =>
    call('get', `hierarchy/coordinators/${coordinatorId}/leaders/`),
  getLeaderVoters: (leaderId, params) =>
    call('get', `hierarchy/leaders/${leaderId}/voters/`, null, params),
  changeVoterLeader: (voterId, leaderId) =>
    call('patch', `voters/${voterId}/reasignar-puntero/`, {
      puntero_id: leaderId,
    }),
};
